import { mode } from '@chakra-ui/theme-tools';

export const textareaStyles = {
  components: {
    Textarea: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: '8px',
        },
      },

      variants: {
        main: (props: any) => ({
          bg: mode('transparent', 'navy.800')(props),
          border: '1px solid',
          borderColor: mode('gray.300', 'whiteAlpha.100')(props),
          fontSize: 'sm',
          p: '20px',
          borderRadius: '16px',
          _placeholder: {
            fontWeight: '400',
            color: 'secondaryGray.600',
          },
          h: '44px',
          maxH: '44px',
          _disabled: {
            backgroundColor: mode('gray.200', 'navy.700')(props),
          },
          fontWeight: 500,
          color: mode('secondaryGray.900', 'white')(props),
          _hover: {
            borderColor: mode('secondaryGray.900', 'white')(props),
          },
          _focus: {
            borderColor: mode('secondaryGray.900', 'white')(props),
          },
          _invalid: {
            borderColor: mode('red.600', 'red.600')(props),
            boxShadow: 'none',
          },
        }),
      },
    },
  },
};
